import { render, staticRenderFns } from "./LogCardDeleted.vue?vue&type=template&id=7271d4e8"
import script from "./LogCardDeleted.vue?vue&type=script&lang=js"
export * from "./LogCardDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports